import { SidebarItem } from '../tabs'

export function getIsActive(
    to: string,
    pathname: string,
    pages?: SidebarItem[],
    otherPaths?: string[],
) {
    if (pages) {
        return pages.some(
            ({ to, otherPaths: pageOtherPaths }) =>
                (to && pathname.includes(to)) ||
                Boolean(pageOtherPaths?.some(path => pathname.includes(path))),
        )
    }

    if (to.includes('enterprise')) {
        // Exact home only — otherwise every `/enterprise/*` page would match.
        if (to === '/enterprise') {
            return pathname === '/enterprise'
        }
        // Prefix match so nested sections (e.g. `/enterprise/standardizations/*`)
        // highlight the correct child, not every sibling under the same segment.
        return (
            pathname === to ||
            pathname.startsWith(`${to}/`) ||
            pathname.startsWith(`${to}?`) ||
            Boolean(otherPaths?.some(path => pathname.includes(path)))
        )
    }

    if (to === '/daily-huddle') {
        return pathname.split('/')[1] === 'daily-huddle'
    }

    return (
        (to === '/' ? pathname === to : pathname.includes(to.split('?')[0])) ||
        Boolean(otherPaths?.some(path => pathname.includes(path)))
    )
}
